import { Home, Ticket, Headphones, User } from 'lucide-react';

interface BottomNavigationProps {
  activePage?: 'home' | 'booking' | 'support' | 'account';
  onAccountClick?: () => void;
  onMyTripsClick?: () => void;
  onHomeClick?: () => void;
  onSupportClick?: () => void;
}

export const BottomNavigation = ({ 
  activePage = 'home', 
  onAccountClick, 
  onMyTripsClick, 
  onHomeClick,
  onSupportClick
}: BottomNavigationProps) => {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E7EB] z-40 safe-area-inset-bottom">
      <div className="flex items-center justify-around px-4 py-3">
        {/* Home / Viajar */}
        <button
          onClick={onHomeClick}
          className={`flex flex-col items-center gap-1 min-w-[60px] transition-colors ${
            activePage === 'home' ? 'text-[#FF6A2A]' : 'text-[#6B7280]'
          }`}
        >
          <Home className="w-6 h-6" />
          <span className="text-xs font-medium">Viajar</span>
        </button>

        {/* Mis viajes / Booking */}
        <button
          onClick={onMyTripsClick}
          className={`flex flex-col items-center gap-1 min-w-[60px] transition-colors ${
            activePage === 'booking' ? 'text-[#FF6A2A]' : 'text-[#6B7280]'
          }`}
        >
          <Ticket className="w-6 h-6" />
          <span className="text-xs font-medium">Mis viajes</span>
        </button>

        {/* Support */}
        <button
          onClick={onSupportClick}
          className={`flex flex-col items-center gap-1 min-w-[60px] transition-colors ${
            activePage === 'support' ? 'text-[#FF6A2A]' : 'text-[#6B7280]'
          }`}
        >
          <Headphones className="w-6 h-6" />
          <span className="text-xs font-medium">Soporte</span>
        </button>

        {/* Account */}
        <button
          onClick={onAccountClick}
          className={`flex flex-col items-center gap-1 min-w-[60px] transition-colors ${
            activePage === 'account' ? 'text-[#FF6A2A]' : 'text-[#6B7280]'
          }`}
        >
          <User className="w-6 h-6" />
          <span className="text-xs font-medium">Cuenta</span>
        </button>
      </div>
    </div>
  );
};